import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { AuthContext } from '../../Context/auth-context';
import Icon from '../UIElements/Icon';
import './NavLinks.css';
const NavLinks = () => {
  const auth = useContext(AuthContext);
  const loggedIn = auth.isDoctorLoggedIn || auth.isPateintLoggedIn || auth.isPharmacyLoggedIn;
  const logoutHandler = () => {
    auth.Dlogout();
    auth.Plogout();
    auth.Phlogout();
  };
  const links = [
    { to: '/', label: loggedIn ? 'Overview' : 'Choose your role', icon: 'grid', exact: true }
  ];
  if (auth.isDoctorLoggedIn)
    links.push(
      { to: '/care/inbox', label: 'Care inbox', icon: 'bell' },
      { to: `/${auth.doctorId}/search`, label: 'Find a patient', icon: 'search' }
    );
  if (auth.isPateintLoggedIn)
    links.push(
      { to: '/care', label: 'Care timeline', icon: 'pulse', exact: true },
      { to: '/care/team', label: 'My care team', icon: 'doctor' },
      { to: `/${auth.patientId}/history`, label: 'Medical history', icon: 'history' },
      { to: `/reports/${auth.patientId}`, label: 'Health reports', icon: 'file' }
    );
  if (auth.isPharmacyLoggedIn)
    links.push(
      { to: '/care/inbox', label: 'Shared patient care', icon: 'heart' },
      { to: `/${auth.pharmacyId}/prescriptions`, label: 'Prescriptions', icon: 'file' },
      { to: `/${auth.pharmacyId}/CRM`, label: 'Refill alerts', icon: 'bell' },
      { to: `/${auth.pharmacyId}/analysis`, label: 'Inventory insights', icon: 'chart' }
    );
  return (
    <ul className="nav-links">
      {links.map((link) => (
        <li key={link.to}>
          <NavLink to={link.to} exact={link.exact}>
            <Icon name={link.icon} />
            <span>{link.label}</span>
          </NavLink>
        </li>
      ))}
      {loggedIn && (
        <li className="nav-logout">
          <button onClick={logoutHandler}>
            <Icon name="logout" />
            <span>Log out</span>
          </button>
        </li>
      )}
    </ul>
  );
};
export default NavLinks;
